import React, { useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import './index.scss';
import NavbarItem from '../NavbarItem';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import ButtonV2 from 'src/components/ButtonV2';
import { useToast } from 'src/hooks/useToast';
import { apiClient } from 'src/api/apiClient';
import { CONTACT_SALES_API } from 'src/constants/httpEndPoints';
import { useProfile } from 'src/hooks/useProfile';
import EnvolopeIcon from 'src/assets/icons/envolope-v2.svg';

interface TrailUserCardProps {
  isExpanded: boolean;
  description: string;
  count: number;
  maxCount: number;
  className?: string;
  label?: string;
}

const TrailUserCard: React.FC<TrailUserCardProps> = ({
  isExpanded,
  description,
  count,
  maxCount,
  className = '',
  label,
}) => {
  // Calculate progress percentage
  const progressValue = maxCount ? ((maxCount - count) / maxCount) * 100 : 100;
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const {emailId,customerId} = useProfile()
  const contactSalesAction =() => {
    setLoading(true)
    apiClient.post(CONTACT_SALES_API, {
      emailId,
      uniqueId: customerId,
    },{
      headers: {
        'X-Login-Email': emailId,
        'X-Customer-Id': customerId,
      },
    }).then(res => {
      if (res.status === 200) {
        toast.success('Message sent to Sales', 'Thank you for reaching out. We’ve notified our sales team. You’ll hear from us within 30 minutes.')
      }
    }).catch((error) => {
      toast.error('Error', 'Failed to send email to sales team.')
    })
    .finally(() => {
      setLoading(false)
    })
  }

  // Default label if not provided
  const displayLabel = label || `Trial Period: ${maxCount} days`;

  if (!isExpanded) {
    return (
      <NavbarItem
        expanded={Boolean(isExpanded)}
        icon={
          <UpdateOutlinedIcon
            className="trail-user-card__icon"
            sx={{ width: 20, height: 20 }}
          />
        }
        title="Trial Period: 7 days"
        permission={true}
        onClick={() => {}}
        isActive={false}
        isLocked={false}
      />
    );
  }

  return (
    <div className={`trail-user-card ${className}`}>
      <div className="trail-user-card__content">
        <div className="trail-user-card__header">
          <div className="trail-user-card__count-section">
            <div className="trail-user-card__count-circle">
              <span className="trail-user-card__count-number">{count}</span>
            </div>
            <div className="trail-user-card__count-text">
              <span className="trail-user-card__label">{displayLabel}</span>
              {/* Progress Bar */}
              <div className="trail-user-card__progress-container">
                <LinearProgress
                  variant="determinate"
                  value={progressValue}
                  className="trail-user-card__progress-bar"
                />
              </div>
            </div>
          </div>
        </div>
        <hr className="trail-user-card__divider" />
        {/* Description Text */}
        <div className="trail-user-card__description">
          {description.split('\n').map((line, index) => (
            <p key={index} className="trail-user-card__description-line">
              {line}
            </p>
          ))}
        </div>

        {/* Contact Support Button */}
        <ButtonV2
          className="trail-user-card__contact-button"
          onClick={contactSalesAction}
          type="primary"
          variant="contained"
          text="Contact Sales"
          size="small"
          id="trail-user-card-contact-sales-button"
          loading={loading}
          disabled={loading}
          startIcon={<img src={EnvolopeIcon} alt="envolope" />}
        />
      </div>
    </div>
  );
};

export default TrailUserCard;
